// Lux Coffee: produktsidan (sections/lux-product.liquid), "Du kanske också gillar." (lux-product-ymal)
// och Kaffeboxen (lux-kaffeboxen). Portat från lux-website/js/produkt.js och js/kaffeboxen.js.
// Köpruta: variantval från produktens alternativ, engångsköp eller prenumeration (Appstle-planer via
// selling_plan_allocations), priser, antal och "Lägg i varukorg." via /cart/add.js utan sidbyte.
// Varukorgens antal i Lux sidhuvud uppdateras (Dawns cartUpdate-händelse + [data-cart-count]).
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var once = function (el, key) { if (!el || el.dataset[key]) return false; el.dataset[key] = "1"; return true; };
  var readJSON = function (el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };

  /* ---------- Pris enligt butikens valutaformat (som Liquids money_without_trailing_zeros) ---------- */
  var formatMoney = function (cents, format) {
    format = format || "{{amount}} kr";
    var num = function (n, decimals, thousands, dec) {
      var s = (n / 100).toFixed(decimals).split(".");
      var whole = s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      return whole + (s[1] && Number(s[1]) !== 0 ? dec + s[1] : "");
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case "amount_no_decimals": return num(cents, 0, ",", ".");
        case "amount_with_comma_separator": return num(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return num(cents, 0, ".", ",");
        case "amount_with_space_separator": return num(cents, 2, " ", ",");
        case "amount_no_decimals_with_space_separator": return num(cents, 0, " ", ",");
        case "amount_with_apostrophe_separator": return num(cents, 2, "'", ".");
        default: return num(cents, 2, ",", ".");
      }
    }).replace(/<[^>]*>/g, "");
  };
  window.LuxMoney = window.LuxMoney || formatMoney;

  /* ---------- Varukorgens antal ---------- */
  var refreshCartCount = function (cartUrl) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return fetch(root + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$("[data-cart-count]").forEach(function (el) { el.textContent = c.item_count; });
        /* global PUB_SUB_EVENTS, publish */
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "lux-product", cartData: c });
        }
        return c;
      })
      .catch(function () {});
  };
  window.LuxRefreshCart = window.LuxRefreshCart || refreshCartCount;

  /* ---------- Köpruta ---------- */
  var initProduct = function (scope) {
    $$("[data-lux-product]", scope).forEach(function (main) {
      if (!once(main, "luxInit")) return;
      var section = main.closest(".shopify-section") || document;
      var product = readJSON($("[data-lux-product-json]", section));
      var cfg = readJSON($("[data-lux-product-config]", section)) || {};
      var form = $("[data-lux-form]", main);
      if (!product || !form) return;
      var fmt = function (c) { return formatMoney(c, cfg.moneyFormat); };

      var idInput = $("[data-lux-variant-input]", form);
      var planInput = $("[data-lux-plan-input]", form);
      var bridge = $("[data-lux-appstle-plan]", main);
      var plansRow = $("[data-lux-plans]", form);
      var qty = $('input[name="quantity"]', form);
      var addBtn = $("[data-lux-add]", form);
      var addLabel = $("[data-lux-add-label]", form);
      var total = $("[data-lux-total]", form);
      var status = $("[data-lux-status]", form);
      var barBtn = $("[data-lux-bar-add]", section);
      var barLabel = $("[data-lux-bar-label]", section);
      var barPrice = $("[data-lux-bar-price]", section);
      var barStatus = $("[data-lux-bar-status]", section);
      var oncePrice = $("[data-lux-once-price]", form);
      var subPrice = $("[data-lux-sub-price]", form);
      var subNote = $("[data-lux-sub-note]", form);

      // Planernas första prisjustering (antal leveranser) per plan-id
      var planInfo = {};
      (product.selling_plan_groups || []).forEach(function (g) {
        (g.selling_plans || []).forEach(function (p) { planInfo[p.id] = p; });
      });

      var checked = function (name) { var el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : ""; };
      var currentVariant = function () {
        if (product.variants.length === 1) return product.variants[0];
        var picks = {};
        $$("[data-lux-option]", form).forEach(function (el) { if (el.checked) picks[el.getAttribute("data-lux-option")] = el.value; });
        return product.variants.filter(function (v) {
          return v.options.every(function (val, i) { return picks[i + 1] === undefined || picks[i + 1] === val; });
        })[0] || null;
      };
      var isSub = function () {
        if (!planInput) return false;
        var mode = checked("purchase");
        return mode ? mode === "subscription" : product.requires_selling_plan;
      };
      var planId = function () { return checked("lux-plan-" + main.getAttribute("data-lux-product")); };
      var allocFor = function (v, id) {
        return (v && v.selling_plan_allocations || []).filter(function (a) { return String(a.selling_plan_id) === String(id); })[0] || null;
      };
      var noteFor = function (a) {
        if (!a) return "";
        var adj = a.price_adjustments || [];
        if (adj.length > 1) {
          var plan = planInfo[a.selling_plan_id];
          var n = (plan && plan.price_adjustments && plan.price_adjustments[0] && plan.price_adjustments[0].order_count) || 1;
          var tpl = n === 1 ? cfg.subThenOne : cfg.subThenMany;
          return (tpl || "").replace("[pris]", fmt(adj[1].price)).replace("[antal]", n);
        }
        if (a.compare_at_price > a.price) {
          var pct = Math.round((a.compare_at_price - a.price) * 100 / a.compare_at_price);
          return (cfg.subSave || "").replace("[procent]", pct);
        }
        return "";
      };

      var update = function () {
        var v = currentVariant();
        var sub = isSub();
        var n = Math.max(1, parseInt(qty.value, 10) || 1);
        if (plansRow) plansRow.hidden = !sub;
        var a = v && sub ? allocFor(v, planId()) : null;
        var ok = !!(v && v.available && (!sub || a));
        var unit = v ? (sub && a ? a.price : v.price) : 0;
        if (v) idInput.value = v.id;
        if (planInput) { planInput.disabled = !sub; planInput.value = sub ? planId() : ""; }
        if (bridge) { bridge.value = sub ? planId() : ""; bridge.checked = sub; }
        if (v && oncePrice) oncePrice.textContent = fmt(v.price);
        if (v && subPrice) {
          var shown = a || allocFor(v, planId()) || (v.selling_plan_allocations || [])[0];
          subPrice.textContent = shown ? fmt(shown.price) : "";
          if (subNote) subNote.textContent = noteFor(shown);
        }
        var label = !v ? cfg.unavailableLabel : (ok ? cfg.addLabel : cfg.soldoutLabel);
        var price = ok ? fmt(unit * n) : "";
        addBtn.disabled = !ok;
        addLabel.textContent = label;
        total.textContent = price;
        if (barBtn) { barBtn.disabled = !ok; barLabel.textContent = label; barPrice.textContent = price; }
        status.textContent = "";
        if (barStatus) barStatus.textContent = "";
      };

      form.addEventListener("change", update);
      qty.addEventListener("input", update);
      qty.addEventListener("blur", function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); update(); });
      $$("[data-qty]", form).forEach(function (b) {
        b.addEventListener("click", function () {
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute("data-qty"), 10));
          update();
        });
      });

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        if (barBtn) barBtn.disabled = true;
        addBtn.setAttribute("aria-busy", "true");
        fetch((cfg.cartAddUrl || "/cart/add") + ".js", {
          method: "POST",
          headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || "");
            status.innerHTML = "";
            status.appendChild(document.createTextNode(cfg.addedText + " "));
            var link = document.createElement("a");
            link.href = cfg.cartUrl || "/cart";
            link.className = "u-hover pbuy__cartlink";
            link.textContent = cfg.cartLinkText;
            status.appendChild(link);
            if (barStatus) barStatus.textContent = cfg.addedText;
            return refreshCartCount();
          })
          .catch(function (err) {
            status.textContent = (err && err.message) || cfg.errorText;
          })
          .then(function () {
            addBtn.removeAttribute("aria-busy");
            var keep = status.innerHTML;
            update();
            status.innerHTML = keep;
          });
      });

      update();
      // Sidan kan komma från bakåt-cache med andra val
      window.addEventListener("pageshow", function (e) { if (e.persisted) update(); });
    });
  };

  /* ---------- Du kanske också gillar: 01/02 ---------- */
  var initYmal = function (scope) {
    $$("[data-ymal-pager]", scope).forEach(function (pager) {
      if (!once(pager, "luxInit")) return;
      var stage = pager.closest(".ymal__stage");
      var buttons = $$("button", pager);
      buttons.forEach(function (b, i) {
        b.addEventListener("click", function () {
          buttons.forEach(function (o, k) { if (k === i) o.setAttribute("aria-current", "true"); else o.removeAttribute("aria-current"); });
          $$(".ymal__slide", stage).forEach(function (s, k) { s.hidden = k !== i; });
        });
      });
    });
  };

  // Shopifys produktrekommendationer: sektionen hämtar sig själv med rekommenderade produkter
  var initRecs = function (scope) {
    $$("[data-lux-recs-url]", scope).forEach(function (el) {
      if (!once(el, "luxInit")) return;
      fetch(el.getAttribute("data-lux-recs-url"))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-lux-recs]");
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            el.hidden = false;
            initYmal(el);
          }
        })
        .catch(function () {});
    });
  };

  /* ---------- Kaffeboxen: Bevaka ---------- */
  var initWatch = function (scope) {
    $$("[data-kb-watch-open]", scope).forEach(function (btn) {
      if (!once(btn, "luxInit")) return;
      var section = btn.closest(".shopify-section") || document;
      var wrap = document.getElementById(btn.getAttribute("aria-controls"));
      if (!wrap) return;
      var input = $('input[type="email"]', wrap);
      var setOpen = function (open) {
        wrap.hidden = !open;
        btn.setAttribute("aria-expanded", String(open));
        if (open && input) input.focus({ preventScroll: true });
      };
      btn.addEventListener("click", function () { setOpen(wrap.hidden); });
      var form = $("form", wrap);
      var status = $("[data-kb-status]", section);
      if (form && input) {
        form.addEventListener("submit", function (e) {
          if (input.checkValidity()) { input.removeAttribute("aria-invalid"); return; }
          e.preventDefault();
          input.setAttribute("aria-invalid", "true");
          if (status) status.textContent = btn.getAttribute("data-invalid-text") || "";
          input.focus();
        });
      }
      var jump = $("[data-kb-watch-jump]", section);
      if (jump && once(jump, "luxInit")) jump.addEventListener("click", function (e) {
        e.preventDefault();
        btn.closest(".pbuy").scrollIntoView({ behavior: "smooth", block: "center" });
        setOpen(true);
      });
    });
  };

  /* ---------- Galleri: bilderna rullar löpande åt vänster (som watchhouse.com) ---------- */
  // Bilderna klonas tills loopen är sömlös och flyttas med transform i jämn takt (data-lux-roll = px/s).
  // Stannar vid tangentbordsfokus i galleriet. Med "minska rörelse" rullar inget och galleriet går att svepa som förut.
  var initRoll = function (scope) {
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    $$("[data-lux-roll]", scope).forEach(function (track) {
      if (!once(track, "luxRollInit")) return;
      var originals = $$(".pgal__slide", track);
      if (originals.length < 2) return;
      var speed = parseFloat(track.getAttribute("data-lux-roll")) || 65;
      track.classList.add("pgal__track--roll");
      var setW = 0, x = 0, last = 0, paused = false;
      var measure = function () {
        setW = originals.reduce(function (s, el) { return s + el.getBoundingClientRect().width; }, 0);
        // Klona hela uppsättningar tills det alltid finns bilder i hela bredden
        while (setW > 0 && track.scrollWidth < setW + track.clientWidth * 1.5) {
          originals.forEach(function (el) {
            var c = el.cloneNode(true);
            c.setAttribute("aria-hidden", "true");
            c.classList.remove("pgal__slide--first");
            $$("img", c).forEach(function (i) { i.setAttribute("alt", ""); i.setAttribute("loading", "lazy"); });
            track.appendChild(c);
          });
        }
      };
      var frame = function (t) {
        if (last && !paused && setW > 0) {
          x += speed * Math.min(t - last, 64) / 1000;
          if (x >= setW) x -= setW;
          track.style.setProperty("--roll", (-x).toFixed(2) + "px");
        }
        last = t;
        requestAnimationFrame(frame);
      };
      measure();
      window.addEventListener("resize", function () { measure(); if (x >= setW) x = 0; });
      track.addEventListener("focusin", function () { paused = track.matches(":focus-visible") || !!track.querySelector(":focus-visible"); });
      track.addEventListener("focusout", function () { paused = false; });
      requestAnimationFrame(frame);
    });
  };

  var init = function (scope) { initProduct(scope); initYmal(scope); initRecs(scope); initWatch(scope); initRoll(scope); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(document); });
  else init(document);
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
